import { getCSRFToken } from './utils'

type PutApi = { put: (path: string, body: unknown) => Promise<unknown> }

/** Shared by the admin Users list and the admin organisation's users table. */
export async function setUserAdminLocked(api: PutApi, userId: string, locked: boolean) {
    await api.put(`/admin/user/${userId}`, {
        user: {
            adminLocked: locked,
        },
        _csrf: await getCSRFToken(),
    })
}
